module.exports = __webpack_public_path__ + "static/scale-model-of-rose-district-fountain-in-tulsa-oklahoma-ae3d845ce45d2238d4756fdd65518090.png";